enum NETWORK_NAME {
  vungle = 'Vungle',
  unity = 'Unity',
  youtube = 'Youtube',
  pangle = 'Pangle',
  mintegral = 'Mintegral',
  tiktok = 'Tiktok',
  facebook = 'Facebook',
  ironsource = 'Ironsource',
  applovin = 'Applovin',
  chartboost = 'Chartboost',
  admob = 'Admob',
  fyber = 'Fyber',
  Others = 'Others',
}

enum PLATFORM_NAME {
  android = 'Android',
  ios = 'iOS',
  Others = 'Others',
}

enum AD_IMPRESSIONS_CHART_TYPE {
  AD_INDEX = 'AD_INDEX',
  AD_SHARE = 'AD_SHARE',
  AD_IMPRESSIONS_WEEKLY_CHANGELOG = 'AD_IMPRESSIONS_WEEKLY_CHANGELOG',
}

export { NETWORK_NAME, PLATFORM_NAME, AD_IMPRESSIONS_CHART_TYPE };
